import React from "react";
import classNames from "classnames";
import FolderIcon from "./FolderIcon";

const DirectoryIcon = ({ className, ...props }) => (
  <FolderIcon className={classNames("file-icon", className)} {...props} />
);

export default DirectoryIcon;
